import { supabase } from '../lib/supabase';

export const subscriptionService = {
  /**
   * Get all subscription tiers (including inactive)
   */
  async getAllTiers() {
    try {
      const { data, error } = await supabase?.from('subscription_tiers')?.select('*')?.order('base_price', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Get all tiers error:', error);
      throw error;
    }
  },

  /**
   * Get active subscription tiers only
   */
  async getActiveTiers() {
    try {
      const { data, error } = await supabase?.from('subscription_tiers')?.select('*')?.eq('is_active', true)?.order('base_price', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching subscription tiers:', error);
      throw error;
    }
  },

  /**
   * Get subscription tier by ID
   */
  async getTierById(tierId) {
    try {
      const { data, error } = await supabase?.from('subscription_tiers')?.select('*')?.eq('id', tierId)?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Get tier by ID error:', error);
      throw error;
    }
  },

  /**
   * Create new subscription tier (super admin only)
   */
  async createTier(tierData) {
    try {
      const { data, error } = await supabase?.from('subscription_tiers')?.insert({
          name: tierData?.name,
          base_price: tierData?.basePrice,
          per_user_price: tierData?.perUserPrice || 0,
          price_type: tierData?.priceType || 'flat',
          features: tierData?.features || [],
          limits: tierData?.limits || {},
          is_active: tierData?.isActive !== undefined ? tierData?.isActive : true,
        })?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Create tier error:', error);
      throw error;
    }
  },

  /**
   * Update subscription tier (super admin only)
   */
  async updateTier(tierId, updates) {
    try {
      const updateData = {};
      
      if (updates?.name !== undefined) updateData.name = updates?.name;
      if (updates?.basePrice !== undefined) updateData.base_price = updates?.basePrice;
      if (updates?.perUserPrice !== undefined) updateData.per_user_price = updates?.perUserPrice;
      if (updates?.priceType !== undefined) updateData.price_type = updates?.priceType;
      if (updates?.features !== undefined) updateData.features = updates?.features;
      if (updates?.limits !== undefined) updateData.limits = updates?.limits;
      if (updates?.isActive !== undefined) updateData.is_active = updates?.isActive;

      const { data, error } = await supabase?.from('subscription_tiers')?.update(updateData)?.eq('id', tierId)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Update tier error:', error);
      throw error;
    }
  },

  /**
   * Delete subscription tier (super admin only)
   */
  async deleteTier(tierId) {
    try {
      const { error } = await supabase?.from('subscription_tiers')?.delete()?.eq('id', tierId);

      if (error) throw error;
    } catch (error) {
      console.error('Delete tier error:', error);
      throw error;
    }
  },

  /**
   * Activate/Deactivate subscription tier (super admin only)
   */
  async toggleTierStatus(tierId, isActive) {
    try {
      const { data, error } = await supabase?.from('subscription_tiers')?.update({ is_active: isActive })?.eq('id', tierId)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Toggle tier status error:', error);
      throw error;
    }
  },
};